import { useEffect, useState } from 'react';
import { config } from '@/config';
import type { Station } from '@/domain/geo';
import { fetchStations } from '@/services/stations';

type StationsState = { stations: Station[]; sourceIsLive: boolean; isLoading: boolean };

export const useStations = (): StationsState => {
  const [state, setState] = useState<StationsState>({
    stations: [],
    sourceIsLive: false,
    isLoading: true,
  });

  useEffect(() => {
    let active = true;
    void fetchStations(config.stationsUrl).then((result) => {
      if (!active) {
        return;
      }
      setState({
        stations: result.stations,
        sourceIsLive: result.source === 'live',
        isLoading: false,
      });
    });
    return () => {
      active = false;
    };
  }, []);

  return state;
};
